import Vue from "vue";

import { rvkadminClient, rvkworkClient } from "@/compose";

function initial() {
  return {
    customers: null,
    unsubmittedTasks: null,
    finishedTasks: {}
  };
}

export default {
  state: initial(),
  getters: {
    customers: state => state.customers,
    unsubmittedTasks: state => state.unsubmittedTasks,
    finishedTasks$1: state => customerName => state.finishedTasks[customerName]
  },
  mutations: {
    reset(state) {
      Object.assign(state, initial());
    },

    updateCustomers(state, customers) {
      state.customers = customers;
    },
    updateUnsubmittedTasks(state, tasks) {
      state.unsubmittedTasks = tasks;
    },
    updateFinishedTasks$1(state, { customerName, tasks }) {
      Vue.set(state.finishedTasks, customerName, tasks);
    }
  },
  actions: {
    loadCustomers(context) {
      rvkadminClient.locationAll().subscribe(response =>
        context.commit(
          "updateCustomers",
          response.map(customer => ({
            name: customer.customerName
          }))
        )
      );
    },
    loadUnsubmittedTasks(context) {
      rvkworkClient.openRhenusOrdersUsingGET().subscribe(response =>
        context.commit(
          "updateUnsubmittedTasks",
          response.map(task => ({
            taskId: task.orderID,
            customerName: task.customerName,
            file1Name: task.vorschlagFileName,
            file2Name: task.auftragFileName,
            file3Name: task.agreementFileName,
            state:
              task.statusauftrag === task.statusvorschlag
                ? task.statusauftrag
                : "NEW",
            date: new Date(task.uploaded)
          }))
        )
      );
    },
    loadFinishedTasks$1(context, customer) {
      rvkworkClient
        .closedOrdersByGivenCustomerNameUsingGET(customer.name)
        .subscribe(response =>
          context.commit("updateFinishedTasks$1", {
            customerName: customer.name,
            tasks: response.map(task => ({
              taskId: task.orderID,
              file1Name: task.vorschlagFileName,
              file2Name: task.auftragFileName,
              file3Name: task.agreementFileName,
              state: task.status === "DELETED" ? "SEND" : task.status,
              date: new Date(task.lastAction)
            }))
          })
        );
    },

    createTask(context, { customer, file1, file2, file3, deleteAfter }) {
      return rvkworkClient
        .filesUsingPOST(file3, file2, customer, deleteAfter, file1)
        .toPromise()
        .then(response => response.orderID);
    },
    submitTask(context, taskId) {
      return rvkworkClient.approvedAdminFilesUsingPOST(taskId).toPromise();
    },
    abortTaskCreation(context, taskId) {
      return rvkworkClient.abortOrderUsingDELETE(taskId).toPromise();
    }
  }
};
